import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=12d3542b"
import script from "./SuppliersTable.vue?vue&type=script&lang=js"
export * from "./SuppliersTable.vue?vue&type=script&lang=js"
import style0 from "./SuppliersTable.vue?vue&type=style&index=0&id=12d3542b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports